
<template>
  <div class="board">
    <div class="font-area" :class="globalTransition">
      <div class="title">
        <p>{{$t('aboutPage.p3.title')}}</p>
      </div>
      <p class="split-line">——</p>
      <div class="p1">
        <p>{{$t('aboutPage.p3.p1')}}</p>
      </div>
    </div>
    <div class="user-item">
      <div class="user-items" v-for="event in userList" :key="event">
        <div class="img-class"></div>
        <img :src="tempHeadImgUrl" alt="DIMER" class="head-img"/>
        <div class="content">
          <p class="name"
             :class="globalTransition">
            {{$t('aboutPage.p3.userInfo.'+event+'.name')}}</p>
          <p class="description"
             :class="globalTransition">
            {{$t('aboutPage.p3.userInfo.'+event+'.description')}}</p>
          <p class="contents"
             :class="globalTransition">
            {{$t('aboutPage.p3.userInfo.'+event+'.content')}}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import tempHeadImg from '@/assets/tempHeadImg.jpg';

export default {
  name: 'aboutCommittee',
  data() {
    return {
      tempHeadImgUrl: tempHeadImg,
      userList_en: ['DrLMS', 'PfPaul', 'MrTJing', 'DrZJ', 'DrPenny', 'DrTao', 'AliciaLi', 'MrYCQ'],
      userList_zh: ['DrLMS', 'PfPaul', 'MrTJing', 'DrZJ', 'DrPenny', 'DrTao', 'AliciaLi', 'MrYCQ'],
    };
  },
  computed: {
    userList() {
      return this[`userList_${this.$store.getters.language}`];
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
};
</script>

<style lang="scss" scoped>
  .board{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f2f2f2;
    padding:100px 10.5%;
    text-align: center;
  }
  .font-area{
    width: 80%;
    .title{
      font-size: 2rem;
      font-weight: bold;
    }
    .p1{
      font-size: 1.1rem;
      line-height: 2rem;
    }
  }
  .user-item{
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-top: 80px;
    .user-items{
      display: flex;
      width: 100%;
      height: auto;
      padding: 25px 0px;
      .img-class{
        height: 100%;
      }
      .head-img{
      }
      .content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        width: 100%;
        padding: 20px 50px;
        .name{
          font-size: 1.5rem;
          font-weight: 600;
          margin-block-end: 0!important;
        }
        .description,.contents{
          font-size: 1.1rem;
        }
        .description{
          margin-block-start: 0!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/aboutPage/board.vue